'use strict';

// Import Libraries
import React      from 'react';
import classNames from 'classnames';
// Import class
import OptionSorter from './option-sorter';

// -----------------------------------------------------------
//  StandardFilterOptions
// -----------------------------------------------------------
const ColorFilterOptions = ({options, selected_options: selectedOptions, facets, onOptionSelected, newUi}) => {
  return (
    <ul className="list-unstyled blob">
      {
        (new OptionSorter(options.filter(option => option.title))).sort().map(renderOption, this)
      }
    </ul>
  );

  function renderOption(option) {
    const selected = selectedOptions.indexOf(option.title) > -1,
          unavailable = (() => {
            if (facets) {
              return !facets.some(facet => facet.key === option.title);
            }

            return !option.available;
          })();

    const handleOptionSelected = (e) => {
      e.preventDefault();
      onOptionSelected(option.title);
    };

    if (unavailable & newUi) return null;
    return (
      <li key={ option.title } className={ classNames('color-picker-option', {selected: selected, unavailable: unavailable}) }>
        <a href='#' onClick={ handleOptionSelected } title={ option.title.toUpperCase() }
          aria-label={option.title}
          aria-checked={selected}
          role='checkbox'>
          <div className={classNames(option.title, 'color-preview')} style={ { background: option.title.replace(/ /g, '') } } />
        </a>
        <div className='color-description'>
          { option.title }
        </div>
      </li>
    );
  }
};

export default ColorFilterOptions;
